// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1DiskSpec
 */
export interface V1DiskSpec {
  /**
   *
   * @type {number}
   * @memberof V1DiskSpec
   */
  size?: number;
  /**
   *
   * @type {number}
   * @memberof V1DiskSpec
   */
  virtSize?: number;
}

/**
 * Check if a given object implements the V1DiskSpec interface.
 */
export function instanceOfV1DiskSpec(value: object): value is V1DiskSpec {
  return true;
}

export function V1DiskSpecFromJSON(json: any): V1DiskSpec {
  return V1DiskSpecFromJSONTyped(json, false);
}

export function V1DiskSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DiskSpec {
  if (json == null) {
    return json;
  }
  return {
    size: json['size'] == null ? undefined : json['size'],
    virtSize: json['virtSize'] == null ? undefined : json['virtSize'],
  };
}

export function V1DiskSpecToJSON(json: any): V1DiskSpec {
  return V1DiskSpecToJSONTyped(json, false);
}

export function V1DiskSpecToJSONTyped(
  value?: V1DiskSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    size: value['size'],
    virtSize: value['virtSize'],
  };
}
